import type { useIntl } from '@leagueplatform/locales';
import type { MultiEnvironmentAction } from '../../types/multi-environment.types';

/**
 * Builds a "run environment sync" menu item for one target environment.
 *
 * The label depends on whether the author has a choice to make. With a single promotion
 * target there's nothing to disambiguate, so the plain wording is kept -- changing it would
 * be a gratuitous copy change for every tenant. With several targets the item has to name
 * the environment, or the menu reads as several identical entries.
 */
export function buildSyncToEnvironmentAction({
  id,
  environmentName,
  isNamed,
  action,
  disabledTooltip,
  formatMessage,
}: {
  id: string;
  environmentName: string;
  isNamed: boolean;
  action: MultiEnvironmentAction['action'];
  disabledTooltip?: string;
  formatMessage: ReturnType<typeof useIntl>['formatMessage'];
}): MultiEnvironmentAction {
  return {
    label: isNamed
      ? formatMessage(
          { id: 'SYNC_TO_ENVIRONMENT_ACTION_NAMED' },
          { environment: environmentName },
        )
      : formatMessage(
          { id: 'SYNC_TO_ENVIRONMENT_ACTION' },
          { environmentName },
        ),
    id,
    action,
    disabledTooltip,
  };
}
